import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Alert,
  Nav,
  NavItem,
  NavLink,
  Pagination,
  PaginationItem,
  TabContent,
  TabPane,
} from 'reactstrap';
import { MuiThemeProvider } from 'material-ui/styles';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import AddIcon from '@material-ui/icons/Add';
import { IconButton } from '@material-ui/core';
import GraphQL from '../../../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../../redux/actions/loadingActions';
import { showNotificationAutoDestroy } from '../../../../shared/components/ShowNotification';
import {
  ITEMS_TAB,
  RECEIPTS_TAB,
  ACTION_NAME,
} from '../../../../shared/utils/constants';
import DateField from '../../../../shared/components/form/DateField';
import renderField from '../../../../shared/components/form/RenderField';
import { currencyMasker } from '../../../../shared/components/form/Masks';
import {
  financialItensByTitle,
  paymentByTitle,
  paymentSaveMutation,
  removePaymentByTitle,
} from '../../../../shared/queries/AccountsReceivableAndPayable';
import Modal from '../../../../shared/components/Modal';
import { columnsItems, columnsReceipts } from './Columns';
import MatTable from '../../../../shared/components/material-table';
import { removeMaskOfCurrencyFields } from '../../../../shared/utils/smartutils';

const TableNav = (props) => {
  const { t, initialize, dispatch, valueTitle, idTitle, isSmartPay, findById } =
    props;

  const [activeTab, setActiveTab] = useState(RECEIPTS_TAB);
  const [paymentsTitle, setPaymentsTitle] = useState([]);
  const [financialItens, setFinancialItens] = useState([]);
  const [totalReceived, setTotalReceived] = useState([]);
  const [deleteItem, setDeleteItem] = useState({});
  const [modal, setModal] = useState(false);
  const [paymentTitle, setPaymentTitle] = useState({
    id: idTitle,
    obs: '',
    payDay: new Date(),
    discount: 0,
    additions: 0,
    value: valueTitle,
  });

  const smartPayRef = useRef(isSmartPay);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleTab = (index) => {
    setActiveTab(index);
  };

  const paymentChange = (field, value) => {
    const updatedPayment = { ...paymentTitle };
    updatedPayment[field] = value;
    setPaymentTitle(updatedPayment);
  };

  const paymentInputChange = (evt) => {
    if (evt) {
      const updatedPayment = { ...paymentTitle };
      const value = removeMaskOfCurrencyFields(evt.target.value);
      updatedPayment[evt.target.name] = value;
      setPaymentTitle(updatedPayment);
    }
  };

  const paymentInputObsChange = (evt) => {
    if (evt) {
      const updatedPayment = { ...paymentTitle };
      updatedPayment[evt.target.name] = evt.target.value;
      setPaymentTitle(updatedPayment);
    }
  };

  const totalizerReceived = (values) => {
    const amount = values.reduce(
      (total, value) => total + value.amountPayment - value.discount,
      0
    );
    setTotalReceived(
      amount.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    );
  };

  const loadPaymentByTitle = (id) => {
    const query = paymentByTitle(id);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.paymentByTitle = res.paymentByTitle.map((item) => ({
          ...item,
        }));
        setPaymentsTitle(res.paymentByTitle);
        totalizerReceived(res.paymentByTitle);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadFinancialItensByTitle = (id) => {
    const query = financialItensByTitle(id);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.financialItensByTitle = res.financialItensByTitle.map((item) => ({
          ...item,
        }));
        setFinancialItens(res.financialItensByTitle);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const addItemClickHandler = () => {
    const mutation = paymentSaveMutation(paymentTitle);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        findById(idTitle);
        loadPaymentByTitle(idTitle);
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const removeItemClickHandler = () => {
    const mutation = removePaymentByTitle(deleteItem);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        toggleModal();
        loadPaymentByTitle(idTitle);
        findById(idTitle);
        hideLoading();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const onClickDeleteItemHandler = (evt, rowData) => {
    setDeleteItem(rowData);
    toggleModal();
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find((a) => a.name === ACTION_NAME.REMOVE).hidden =
        smartPayRef.current;
    }
  };

  useEffect(() => {
    loadFinancialItensByTitle(idTitle);
  }, []);

  useEffect(() => {
    initialize(paymentTitle);
    if (paymentTitle && paymentTitle.id) {
      loadPaymentByTitle(paymentTitle.id);
    }
  }, [paymentTitle]);

  useEffect(() => {
    smartPayRef.current = isSmartPay;
  }, [isSmartPay]);

  return (
    <MuiThemeProvider>
      <>
        <Modal
          color="warning"
          title={t('notifications.attention')}
          btn="Warning"
          message={t('notifications.delete_modal')}
          toggle={toggleModal}
          modal={modal}
          onConfirm={removeItemClickHandler}
        />
        <div className="tabs tabs--justify tabs--bordered-bottom overflow-hidden">
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === RECEIPTS_TAB,
                  })}
                  onClick={() => {
                    toggleTab(RECEIPTS_TAB);
                  }}
                >
                  {t('general.receipts')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: activeTab === ITEMS_TAB,
                  })}
                  onClick={() => {
                    toggleTab(ITEMS_TAB);
                  }}
                >
                  {t('general.itens')}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={RECEIPTS_TAB}>
                {isSmartPay ? (
                  <Alert color="danger">
                    {t('notifications.smartPay-titles-not-edited')}
                  </Alert>
                ) : (
                  <>
                    <div className="form__form-group--3_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('general.date')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="payDay"
                            component={DateField}
                            selected={new Date()}
                            onChange={(value) => paymentChange('payDay', value)}
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('general.discounts-fees')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="discount"
                            type="text"
                            component={renderField}
                            onBlur={(evt) => paymentInputChange(evt)}
                            {...currencyMasker()}
                          />
                        </div>
                      </div>
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('general.interest-fines')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="additions"
                            type="text"
                            component={renderField}
                            onBlur={(evt) => paymentInputChange(evt)}
                            {...currencyMasker()}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form__form-group--3_columns">
                      <div className="form__form-group">
                        <span className="form__form-group-label">
                          {t('general.amount-received')}
                        </span>
                        <div className="form__form-group-field">
                          <Field
                            name="value"
                            type="text"
                            component={renderField}
                            onBlur={(evt) => paymentInputChange(evt)}
                            {...currencyMasker()}
                          />
                        </div>
                      </div>
                      <div className="form__form-group--2_columns d-flex flex-grow-1">
                        <div className="form__form-group">
                          <span className="form__form-group-label">
                            {t('general.note')}
                          </span>
                          <div className="form__form-group-field">
                            <Field
                              name="obs"
                              type="text"
                              maxLength="250"
                              component={renderField}
                              onBlur={(evt) => paymentInputObsChange(evt)}
                            />
                          </div>
                        </div>
                        <div className="form__form-group-field flex-1">
                          <IconButton
                            aria-label="add"
                            onClick={addItemClickHandler}
                          >
                            <AddIcon />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="form__form-group">
                  <MatTable
                    data={paymentsTitle}
                    columns={columnsReceipts(t)}
                    onRemoveClick={onClickDeleteItemHandler}
                    toolbar={false}
                    actionsDisabled={isSmartPay}
                    actionsDisabledByConditional={actionsDisabledByConditional}
                  />
                  <Pagination className="form__form-group d-flex mt-4">
                    <PaginationItem className="form__form-group-label">
                      {t('general.total')}
                    </PaginationItem>
                    <PaginationItem className="h5 ml-2 text-success">
                      {totalReceived}
                    </PaginationItem>
                  </Pagination>
                </div>
              </TabPane>
            </TabContent>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={ITEMS_TAB}>
                <div className="form__form-group">
                  <MatTable
                    data={financialItens}
                    columns={columnsItems(t)}
                    paging={false}
                    showTitle={false}
                    search={false}
                    toolbar={false}
                  />
                </div>
              </TabPane>
            </TabContent>
          </div>
        </div>
      </>
    </MuiThemeProvider>
  );
};

TableNav.propTypes = {
  t: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  valueTitle: PropTypes.number.isRequired,
  idTitle: PropTypes.number.isRequired,
  isSmartPay: PropTypes.bool.isRequired,
  findById: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'TableNav',
})(withTranslation('common')(TableNav));
